import { inject, ModuleWithProviders, NgModule } from '@angular/core';
import { PortalConfig } from '@ui/shared/model';
import { portalsConfig } from './portals.config';
import {
  CREDENTIAL_VALIDATOR,
  FTP_CONNECTION_VALIDATOR
} from './services/credential-validator.service';
import {
  PORTALS_CONFIG,
  PORTALS_CONFIG_MAP
} from './tokens/portals-config.token';

function portalsConfigMapFactory(configs: PortalConfig[]) {
  return configs.reduce((total, current) => {
    return {
      ...total,
      [current.portalId]: current
    };
  }, {});
}

@NgModule()
export class PortalsModule {
  public static forRoot(): ModuleWithProviders<PortalsModule> {
    return {
      ngModule: PortalsModule,
      providers: [
        { provide: PORTALS_CONFIG, useValue: portalsConfig },
        {
          provide: PORTALS_CONFIG_MAP,
          useFactory: portalsConfigMapFactory,
          deps: [PORTALS_CONFIG]
        }
      ]
    };
  }

  constructor() {
    const credentialValidator = inject(CREDENTIAL_VALIDATOR, {
      optional: true
    });
    const ftpConnectionValidator = inject(FTP_CONNECTION_VALIDATOR, {
      optional: true
    });

    if (!credentialValidator || !ftpConnectionValidator) {
      console.warn(
        'CredentialValidator or ftpConnectionValidator have not been provided!'
      );
    }
  }
}
